(function (global) {
  'use strict';

  function findMainVariantOption(options, id) {
    var requested = String(id || '').trim();
    if (!requested) return null;
    return Array.from(options || []).find(function (option) {
      return option && String(option.value) === requested;
    }) || null;
  }

  function findProductOptionButton(buttons, names, value) {
    var expected = String(value || '');
    var allowedNames = (names || []).map(function (name) { return String(name).toLocaleLowerCase('tr-TR'); });
    return Array.from(buttons || []).find(function (button) {
      return button && !button.disabled && button.dataset &&
        allowedNames.includes(String(button.dataset.optionName || '').toLocaleLowerCase('tr-TR')) &&
        String(button.dataset.optionValue || '') === expected;
    }) || null;
  }

  function initialize() {
    var doc = global.document;
    if (!doc || doc.__hanezzaOutfitPageSyncReady) return;
    doc.__hanezzaOutfitPageSyncReady = true;
    var synchronizing = false;

    function pageVariantId() {
      var input = doc.querySelector('#product-form-desktop input[name="id"]') ||
        doc.querySelector('#product-form-mobile input[name="id"]');
      return input ? String(input.value || '') : '';
    }

    // Activate only for explicitly configured color-rule combinations.
    function mainVariantSelectors() {
      return Array.from(doc.querySelectorAll('[data-hzcl-root]')).filter(function (root) {
        try {
          var rules = JSON.parse(root.dataset.hzclColorRules || '[]');
          return Array.isArray(rules) && rules.length > 0;
        } catch (_) { return false; }
      }).map(function (root) {
        return root.querySelector('[data-hzcl-main] [data-hzcl-variant]');
      }).filter(Boolean);
    }

    function syncWidgetsFromPage() {
      if (synchronizing) return;
      var id = pageVariantId();
      if (!id) return;
      synchronizing = true;
      try {
        mainVariantSelectors().forEach(function (selector) {
          var match = findMainVariantOption(selector.options, id);
          if (!match || selector.value === match.value) return;
          selector.value = match.value;
          selector.dispatchEvent(new global.Event('change', { bubbles: true }));
        });
      } finally { synchronizing = false; }
    }

    function syncPageFromWidget(selector) {
      if (synchronizing) return;
      var variant = selector && findMainVariantOption(selector.options, selector.value);
      if (!variant || variant.disabled) {
        syncWidgetsFromPage();
        return;
      }
      if (pageVariantId() === variant.value) {
        syncWidgetsFromPage();
        return;
      }
      var topButtons = doc.querySelectorAll(
        '#product-form-desktop .variant-option, #product-form-mobile .variant-option'
      );
      var colorButton = findProductOptionButton(topButtons, ['Renk', 'Color'], variant.dataset.color);
      var sizeButton = findProductOptionButton(topButtons, ['Beden', 'Size'], variant.dataset.size);
      if (!colorButton || !sizeButton) {
        syncWidgetsFromPage();
        return;
      }

      synchronizing = true;
      try {
        if (!colorButton.classList.contains('selected')) colorButton.click();
        if (pageVariantId() !== variant.value) {
          sizeButton = findProductOptionButton(topButtons, ['Beden', 'Size'], variant.dataset.size);
          if (sizeButton) sizeButton.click();
        }
      } finally { synchronizing = false; }
      syncMobileGallery(colorButton);
      syncWidgetsFromPage();
    }

    function syncMobileGallery(colorButton) {
      if (!colorButton) return;
      var mediaId = colorButton.dataset.imageId;
      var slider = doc.getElementById('mobile-image-slider');
      if (!mediaId || !slider) return;
      var slide = Array.from(slider.querySelectorAll('[data-media-id]')).find(function (el) {
        return String(el.dataset.mediaId) === String(mediaId);
      });
      if (!slide) return;
      slider.scrollLeft = slide.offsetLeft;
      if (typeof slide.scrollIntoView === 'function') {
        slide.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
      }
    }

    function resetRecommendedCompanion(button) {
      var root = button && button.closest('[data-hzcl-root]');
      if (!root) return;
      var source = root.querySelector('[data-hzcl-main] [data-hzcl-variant]');
      var item = button.closest('[data-hzcl-item]');
      var select = item && item.querySelector('[data-hzcl-variant]');
      if (!source || !select) return;
      var main = source.options[source.selectedIndex];
      var current = select.options[select.selectedIndex];
      var rules;
      try { rules = JSON.parse(root.dataset.hzclColorRules || '[]'); }
      catch (_) { return; }
      if (!main || !Array.isArray(rules)) return;
      var sourceColor = String(main.dataset.color || '').toLocaleLowerCase('tr-TR');
      var matchedRule = rules.find(function (rule) {
        return String(rule.sourceColor || '').toLocaleLowerCase('tr-TR') === sourceColor &&
          String(rule.targetProductId || '').split('/').pop() === String(item.dataset.hzclProductId || '');
      });
      if (!matchedRule) return;
      var shades = [matchedRule.targetColor].concat(matchedRule.alternativeColors || []);
      var choices = Array.from(select.options).filter(function (opt) { return !opt.disabled; });
      var chosen = null;
      for (var i = 0; i < shades.length && !chosen; i++) {
        var shade = String(shades[i] || '').toLocaleLowerCase('tr-TR');
        var candidates = choices.filter(function (opt) {
          return String(opt.dataset.color || '').toLocaleLowerCase('tr-TR') === shade;
        });
        chosen = candidates.find(function (opt) {
          return current && opt.dataset.size === current.dataset.size;
        }) || candidates[0] || null;
      }
      if (!chosen) return;
      item.dataset.hzclManualColor = 'false';
      if (chosen.value !== select.value) {
        select.value = chosen.value;
        select.dispatchEvent(new global.Event('change', { bubbles: true }));
      }
      button.hidden = true;
    }

    doc.addEventListener('click', function (event) {
      var button = event.target && event.target.closest &&
        event.target.closest('#product-form-desktop .variant-option, #product-form-mobile .variant-option');
      if (button) syncWidgetsFromPage();
      var reset = event.target && event.target.closest &&
        event.target.closest('[data-hzcl-reset-color]');
      if (reset) resetRecommendedCompanion(reset);
    });
    doc.addEventListener('change', function (event) {
      var target = event.target;
      if (!target || !target.matches) return;
      if (target.matches('[data-hzcl-main] [data-hzcl-variant]') &&
          target.closest('[data-hzcl-root]')) {
        syncPageFromWidget(target);
      } else if (target.matches('#product-form-desktop input[name="id"], #product-form-mobile input[name="id"]')) {
        syncWidgetsFromPage();
      }
    });
    global.addEventListener('popstate', syncWidgetsFromPage);
    doc.addEventListener('shopify:section:load', syncWidgetsFromPage);
    syncWidgetsFromPage();
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { findMainVariantOption: findMainVariantOption,
      findProductOptionButton: findProductOptionButton };
  }
  if (global.document) {
    if (global.document.readyState === 'loading') {
      global.document.addEventListener('DOMContentLoaded', initialize);
    } else {
      initialize();
    }
  }
})(typeof window !== 'undefined' ? window : globalThis);
